<app-loader *ngIf="isLoading"></app-loader>
<form method="post" *ngIf="!isLoading" [formGroup]="tenantForm">
  <div class="col-6">
    <div class="form-group">
      <label>Név<span class="required-label" *ngIf="name.errors?.['required']">*</span></label>
      <input id="name" type="text" class="form-control" formControlName="name" />
    </div>
    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert alert-danger">
      <div *ngIf="name.errors?.['required']">A terület neve kötelező.</div>
      <div *ngIf="name.errors?.['serverError']">{{name.errors?.['serverError']}}</div>
    </div>

    <div class="form-group">
      <label>Szakrendszer azonosító<span class="required-label" *ngIf="systemId.errors?.['required']">*</span></label>
      <input id="systemId" type="text" class="form-control" formControlName="systemId" />
    </div>
    <div *ngIf="systemId.invalid && (systemId.dirty || systemId.touched)" class="alert alert-danger">
      <div *ngIf="systemId.errors?.['required']">A szakrendszer azonosító kötelező.</div>
      <div *ngIf="systemId.errors?.['pattern']">
        A szakrendszer azonosító nem megfelelő formátumú! (Szükséges formátum: Guid pl.
        d3f3b796-985e-4e86-835c-9f74d0804677
      </div>
      <div *ngIf="systemId.errors?.['serverError']">{{systemId.errors?.['serverError']}}</div>
    </div>
    <div class="form-check">
      <input id="examReportModifiableLater" type="checkbox" class="form-check-input"
             [checked]="examReportModifiableLater.value" formControlName="examReportModifiableLater" />
      <label for="examReportModifiableLater">Utólagos jegyzőkönyv módosítás engedélyezett</label>
    </div>

    <div class="button-group">
      <button (click)="onSubmit()" class="btn btn-primary text-white btn-save me-2" [disabled]="tenantForm.invalid">
        Mentés
      </button>
      <a
        (click)="onGoBack('/tenants')"
        class="btn btn-dark"> Vissza </a>
    </div>
  </div>
</form>
